import { Button } from '@modusign/design-system';
import { forwardRef } from 'react';

interface ThinButtonProps extends React.ComponentProps<typeof Button> {}

/**
 * TODO(@taehwanno): button의 weight에 thin 추가된 후 해당 컴포넌트는 정리돼야합니다.
 * @see https://github.com/modusign/design-system/pull/238
 */
export const ThinButton = forwardRef<HTMLButtonElement, ThinButtonProps>(
  (props: ThinButtonProps, ref) => {
    return (
      <Button
        {...props}
        fontSize="13px"
        height="30px"
        px={4}
        py={1}
        ref={ref}
        variant="subtle"
        weight="light"
        width="narrow"
      />
    );
  }
);
